/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useEffect, useReducer, useState } from "react";
import { useAuth } from "./auth";
import axios from "axios";

const initialState = {
  tryon: [],
};

const tryonReducer = (state, action) => {
  switch (action.type) {
    case "SET_TRYON":
      return { tryon: action.payload };
    case "ADD_TO_TRYON":
      return { tryon: [...state.tryon, action.payload] };
    case "REMOVE_FROM_TRYON":
      return {
        tryon: state.tryon.filter((item) => item.id !== action.payload),
      };
    default:
      return state;
  }
};

const TryonContext = createContext();

export const TryonProvider = ({ children }) => {
  const [state, dispatch] = useReducer(tryonReducer, initialState);
  const [auth] = useAuth();
  const [tryonData, setTryonData] = useState(null);

  const refreshTryon = (newData) => {
    setTryonData(newData); // 👈 ye re-render trigger karega
  };

  useEffect(() => {
    if (auth?.user?.id) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/customer/aitryon`, {
          params: { customer_id: auth.user.id },
        })
        .then((response) => {
          dispatch({ type: "SET_TRYON", payload: response.data });
        })
        .catch((error) => {
          console.error("Error fetching tryon:", error);
        });
    }
  }, [auth]);

  const addToTryon = async (userId, productId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/customer/aitryon/add`,
        { customer_id: userId, product_id: productId }
      );

      if (response.status === 200) {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/customer/aitryon`,
          { params: { customer_id: userId } }
        );

        dispatch({ type: "SET_TRYON", payload: data });

        return response.data;
      }
    } catch (error) {
      console.error("Error adding item to tryon:", error);
      return { status: false, message: "Something went wrong!" };
    }
  };

  const removeFromTryon = async (userId, productId, confirm = 1) => {
    try {
      if (confirm === 1) {
        const confirmDelete = window.confirm(
          "Are you sure you want to remove this item?"
        );
        if (!confirmDelete) return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/customer/aitryon/remove`,
        { params: { customer_id: userId, product_id: productId } }
      );

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/customer/aitryon`,
        {
          params: { customer_id: userId },
        }
      );

      dispatch({ type: "SET_TRYON", payload: data });
      return response.data;
      
    } catch (error) {
      console.error("Error removing item from tryon:", error);
    }
  };

  return (
    <TryonContext.Provider
      value={{ ...state, addToTryon, removeFromTryon, refreshTryon, tryonData}}
    >
      {children}
    </TryonContext.Provider>
  );
};

export const useTryon = () => useContext(TryonContext);

